export default "__VITE_ASSET__FF5Yw2u___"